import { createExportAPIClient, createHealthAPIClient } from '@api/MyTripsAPIClientFactory'
import { LoadState } from '@util/types'
import { createCarHealthAPIClient } from '@api/BffAPIClientFactory'
import { CarHealth, CarHealthAggregateStateEnum } from '@clients/bff'

const healthApiClient = createHealthAPIClient()
const carHealthApiClient = createCarHealthAPIClient()
const exportApiClient = createExportAPIClient()

function createState () {
  return {
    carHealth: {
      status: LoadState.None,
      vehicleId: null,
      response: {
        aggregateState: CarHealthAggregateStateEnum.UNPLUGGED,
        lastFuelLevel: null,
        healthIssues: {
          warnings: [],
          recommendations: []
        },
        maintenanceItems: []
      } as CarHealth,
    },
    exportHealth: {
      status: LoadState.None,
    },
  }
}

export default {
  namespaced: true,
  state: createState,
  mutations: {
    CAR_HEALTH_REQUEST (state, payload) {
      state.carHealth.status = LoadState.Loading
      state.carHealth.vehicleId = payload
    },
    CAR_HEALTH_RESPONSE (state, payload) {
      state.carHealth.status = LoadState.Success
      state.carHealth.response = payload
    },
    CAR_HEALTH_ERROR_RESPONSE (state, payload) {
      state.carHealth.status = LoadState.Error
      state.carHealth.response = payload
    },
    EXPORT_CAR_HEALTH_REQUEST (state) {
      state.exportHealth.status = LoadState.Loading
    },
    EXPORT_CAR_HEALTH_RESPONSE (state) {
      state.exportHealth.status = LoadState.Success
    },
    EXPORT_CAR_HEALTH_ERROR_RESPONSE (state) {
      state.exportHealth.status = LoadState.Error
    },
    REMOVE_MAINTENANCE_ITEM (state, payload) {
      state.carHealth.response.maintenanceItems =
        state.carHealth.response.maintenanceItems.filter(item => item.id !== payload.id)
    },
    RESET_EXPORT_CAR_HEALTH (state) {
      state.exportHealth.status = LoadState.None
    },
    RESET_FETCH_CAR_HEALTH (state) {
      state.carHealth.status = LoadState.None
    }
  },
  actions: {
    fetchCarHealth ({ commit, getters }, { vehicleId, refresh = false }) {
      if (!refresh && getters.getCarHealthStatus === LoadState.Success && getters.getCarHealthVehicleId === vehicleId) {
        return Promise.resolve(getters.getCarHealth)
      }

      if (!refresh) {
        commit('CAR_HEALTH_REQUEST', vehicleId)
      }

      return new Promise((resolve, reject) => {
        carHealthApiClient
          .getCarHealth(vehicleId)
          .then((response) => {
            commit('CAR_HEALTH_RESPONSE', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            commit('CAR_HEALTH_ERROR_RESPONSE', error.response)
            reject(error)
          })
      })
    },
    checkMaintenanceItem ({ commit, dispatch }, { vehicleId, maintenanceItem }) {
      return new Promise((resolve, reject) => {
        healthApiClient
          .checkMaintenanceItem(vehicleId, maintenanceItem.id, { checked: true })
          .then((response) => {
            if (response.status === 204) {
              commit('REMOVE_MAINTENANCE_ITEM', maintenanceItem)
            }
            dispatch('fetchCarHealth', { vehicleId, refresh: true })
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    exportCarHealth ({ commit }, { vehicleId, email, from, until }) {
      commit('EXPORT_CAR_HEALTH_REQUEST')
      return new Promise((resolve, reject) => {
        exportApiClient.exportHealth({ vehicleId, email, from, until })
          .then((response) => {
            if (response.status === 204) {
              commit('EXPORT_CAR_HEALTH_RESPONSE')
              resolve(response)
            }
          })
          .catch((error) => {
            commit('EXPORT_CAR_HEALTH_ERROR_RESPONSE')
            reject(error)
          })
      })
    },
    resetCarHealth ({ commit }) {
      commit('RESET_FETCH_CAR_HEALTH')
    }
  },
  getters: {
    getCarHealth: state => state.carHealth.response,
    getCarHealthStatus: state => state.carHealth.status,
    getCarHealthVehicleId: state => state.carHealth.vehicleId,
    getExportCarHealthStatus: state => state.exportHealth.status,
  },
}

